import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { Button, Col, Container, Form, Label, Row } from "reactstrap";
import { useCompanyCore } from "../../../cores/company";
import { useUserCore } from "../../../cores/user";
import { InputWembii } from "../InputWembii";
import AssignUserRow from "./AssignUserRow";

type Props = {
  onOpenCreateUser?: (email: string) => void;
  canCreateUser?: boolean;
};

export default function SearchUserForm({
  onOpenCreateUser,
  canCreateUser = true,
}: Props) {
  const intl = useIntl();
  const [email, setEmail] = useState("");
  const [searched, setSearched] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const { userSearched, getUser } = useUserCore();
  const { userIds } = useCompanyCore();

  const onSubmit = useCallback(
    async (e?: any) => {
      if (e) e.preventDefault();
      setIsSearching(true);
      setSearched(true);
      await getUser(email);
      setIsSearching(false);
    },
    [getUser, email]
  );

  const isUserAssigned = useCallback(() => {
    if (userSearched) {
      return userIds.includes(parseInt(userSearched?.id!));
    } else {
      return false;
    }
  }, [userIds, userSearched]);

  const showNotFound =
    searched && !isSearching && !userSearched;

  return (
    <Container className="h-100" fluid>
      <Row>
        <Col>
          <div className="d-flex flex-column h-100 justify-content-center p-4">
            <h2 className="h2 text-center mb-4">
              {intl.formatMessage({ id: "app.asiggnUser.title" })}
            </h2>
            <Form className="px-2" onSubmit={onSubmit}>
              <InputWembii
                type="email"
                placeholder="Email"
                rounded
                className="mt-1"
                value={email}
                mb={false}
                flat
                onChange={(v) => setEmail(v)}
                icon={
                  <FontAwesomeIcon
                    icon={["fas", "search"]}
                    size="1x"
                    color="grey"
                    className="m-1 pointer z-index-50"
                    onClick={onSubmit}
                  />
                }
              />
              <div className="mt-4">
                {!searched && (
                  <Label className="text-muted text-center w-100 p-4">
                    {intl.formatMessage({ id: "app.asiggnUser.logEmail" })}
                  </Label>
                )}
                {isSearching && (
                  <Label className="text-muted text-center w-100 p-4">
                    {intl.formatMessage({ id: "app.asiggnUser.searching" })}
                  </Label>
                )}
                {showNotFound && (
                  <>
                    <Label className="text-muted text-center w-100 p-4">
                      {intl.formatMessage({ id: "app.asiggnUser.noFindUser" })}
                    </Label>
                    {onOpenCreateUser && (
                      <div className="text-center">
                        <Button
                          color="primary"
                          outline
                          disabled={!canCreateUser}
                          type="button"
                          onClick={() => onOpenCreateUser(email)}
                        >
                          {intl.formatMessage({
                            id: "app.asiggnUser.createNewUser",
                          })}
                        </Button>
                      </div>
                    )}
                  </>
                )}
                {searched &&
                  !isSearching &&
                  userSearched &&
                  (!isUserAssigned() ? (
                    <AssignUserRow key={userSearched.id} user={userSearched} />
                  ) : (
                    <Label className="text-muted text-center w-100 p-4">
                      {intl.formatMessage({
                        id: "app.asiggnUser.UserAsiggnUser",
                      })}
                    </Label>
                  ))}
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
